import { render } from "./VisitorPrintBadge.vue?vue&type=template&id=59a4873e"
import script from "./VisitorPrintBadge.vue?vue&type=script&lang=js"
export * from "./VisitorPrintBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__